import DestinationCarousel from './DestinationCarousel.component';
export default DestinationCarousel;